//Ce fichier rassemble toutes les fonctions d'appel utilisée en rapport avec l'utilisateur

import { CallEndpoint } from "./WSGandara";



//#region Login

/**
 * Vérifie si l'URI est cannonique (pas besoin de code d'entreprise)
 * @returns boolean
 */
const IsURICanonnical = async () => {
  //L'url utilisé pour récupérer l'url du webservice
  let _urlTemp = "https://extranet.palissot.fr/extranet/inc_librairie/GMAO/WSGandara.fct.php?endpoint=GMAO";
  let _uri = window.location.host;

  //TODO : Endpoint
  //TEMP

  // return ["test.gandarasolution.fr:3000",].includes(_uri);

  //

  return await CallEndpoint("IsURICannonical", { uri: _uri }, () => { }, true, _urlTemp);

}


/**
 * Récupère l'url du Webservice à utiliser.
 * @param {string} codeOrURL Le code d'entreprise ou l'url à tester 
 * @param {Function} setResponse La callback pour la réponse 
 */
const GetURLWs = async (codeOrURL, setResponse) => {
  //L'url utilisé pour récupérer l'url du webservice
  let _urlTemp = "https://extranet.palissot.fr/extranet/inc_librairie/GMAO/WSGandara.fct.php?endpoint=GMAO";
  // _urlTemp = "https://dev.extranet.gandarasolution.fr/extranet/inc_librairie/GMAO/WSGandara.fct.php?endpoint=GMAO";
  // await CallEndpoint("GetURLWsEntreprise", { codeEntreprise: 'test2' }, setResponse, false, _urlTemp);
  await CallEndpoint("GetURLWsEntreprise", { codeEntreprise: codeOrURL }, setResponse, false, _urlTemp);

}


/**
 * Récupère le token de connexion
 * @param {string} login 
 * @param {String} pass 
 * @param {string} wsForToken 
 * @param {Function} setToken 
 */
const Connexion = async (login, pass, wsForToken, setToken) => {

  const callbackSet = (data) => {
    var base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

//Si la réponse est b64 (le token) ou un chiffre (erreur) on retourne, sinon on retourne 500 (erreur)
    if (base64regex.test(data) || !isNaN(data))
    {
      setToken(data);
    }else{
      setToken(500);
    }


    // if (data === "Erreur de connexion" || !base64regex.test(data)) {
    //   if(isNaN)
    //   {
    //     setToken(500);
    //   }else{
    //     setToken(data);
    //   }
    //    }
    // else {
    //   setToken(data);
    // }
  }
  await CallEndpoint("Connexion", { login: login, pass_clear: pass }, callbackSet, false, wsForToken);
};

//#endregion


//#region Gestion de mot de passe

/**
 * 
 * @param {string} mail 
 * @param {Function} setData 
 */
const CreateTokenMDP = async (mail, setData, _wsForToken, _wsEndpoint) => {
  await CallEndpoint("CreateTokenMDP", { mail: mail }, setData, false, _wsForToken, _wsEndpoint);
}


/**
 * 
 * @param {string} token 
 * @param {string} newMdp 
 * @param {Function} setData 
 */
const ChangeMDP = async (token, newMdp, setData, _urlToUse, _wsToUse) => {
  // console.log(_urlToUse);
  await CallEndpoint("ChangeMDP", {
    token: token,
    newMDP: newMdp,
  }, setData, false, _urlToUse, _wsToUse);
}



const CheckTokenMDP = async(token,isFirst, setData, _urlToUse, _wsToUse) => {
  await CallEndpoint("CheckTokenMDP",{
    token: token,
    isFirst: isFirst,
  },setData, false,_urlToUse,_wsToUse);
}



// /**
//  * 
//  * @param {string} token 
//  * @param {string} newMdp 
//  * @param {Function} setData 
//  */
// const UpdateMDP = async (token, newMdp, setData) => {
//   await CallEndpoint("_UpdateMdp", {
//     token: token,
//     newMdp: newMdp,
//   }, setData);
// }

//#endregion


//#region Informations

/**
 * 
 * @param {string} token 
 * @param {Function} setData 
 */
const GetListeParametres = async (token, setData) => {
  await CallEndpoint("GetListeParametres", {
    token: token,
  }, setData);
};


/**
 * 
 * @param {string} token 
 * @param {Function} setData 
 */
const GetClientSiteContrat = async (token, setData) => {
  await CallEndpoint("GetClientSiteContrat", { token: token }, setData);
};



/**
 * 
 * @param {string} token 
 * @param {string} search 
 * @param {Function} setData 
 */
const GetClientSiteBySearch = async (token, search, setData) => {

  await CallEndpoint("GetClientSiteBySearch", { token: token, search: search }, setData);
}


//#endregion

export {
  //login
  IsURICanonnical
  , GetURLWs
  , Connexion
  //Gestion MDP
  , CreateTokenMDP
  , ChangeMDP
  // , UpdateMDP
  //Infos
  , GetListeParametres
  , GetClientSiteContrat
  , GetClientSiteBySearch
  ,CheckTokenMDP
}


